import { configureStore } from '@reduxjs/toolkit'
import dealPartyReducer from './reducer/deal_party'

export default configureStore({
  reducer: {
    dealParty: dealPartyReducer,
  },
});
